import { withText } from './Text';
import { H1Title } from './Text.styles';

const PrimaryTitle = withText(H1Title);

PrimaryTitle.displayName = 'PrimaryTitle';

export { PrimaryTitle };
